import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

const contactsRootObj = {
  '/app/contacts/persons': 0,
  '/app/contacts/companies': 1
}

class ContactsUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const selectedTabIndexSession = contactsRootObj[this.component.props.location.pathname];

    //const selectedTabIndex = this.component.props.app.contactUpdatePageTabIndex;

    this.component.props.dispatch({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: selectedTabIndexSession
      }
    });

    this.component.setState({
      activeTab: selectedTabIndexSession,
      value: selectedTabIndexSession,
    });
  }
}

export default new ContactsUpdateWillMount();
